// Portado de src/config/site.ts do site Astro.
// Credenciais: apenas a lista oficial fechada do projeto. A menção a
// "Hospital Albert Einstein" que existia no arquivo do Astro foi omitida por
// não constar na lista oficial.

export const SITE = {
  nome: "Dr. Thiago Viana",
  clinica: "ITV — Instituto Dr. Thiago Viana",
  locale: "pt-BR",
} as const;

export const MEDICO = {
  nomeCompleto: "Dr. Thiago de A. O. F. Viana",
  crm: "CRM-SP 144.585",
  especialidades: [
    { nome: "Nutrologia", rqe: "RQE 121770" },
    { nome: "Medicina do Esporte", rqe: "RQE 118488" },
    { nome: "Ortopedia e Traumatologia", rqe: "RQE 113822" },
  ],
  formacao:
    "Médico formado pela Universidade Federal de São Paulo, Escola Paulista de Medicina (UNIFESP-EPM), em 2010",
  sociedades: ["ABRAN", "SBMEE", "SBEMO", "EBOM", "PABOM", "SBOT", "SBCOC"],
} as const;

// NAP — idêntico ao perfil do Google do consultório.
export const NAP = {
  logradouro: "Av. Getúlio Vargas, 22-25, Sala 7, Torre 2",
  bairro: "Jardim Europa",
  cidade: "Bauru",
  uf: "SP",
  cep: "17017-383",
  pais: "BR",
  telefone: "(14) 99822-0707",
  telefoneE164: "+5514998220707",
  email: "consultorio@drthiagoviana.com",
} as const;

export const MAPS_PLACE_ID = "ChIJIxiJOI9nv5QRdlbeI2hcers";
export const MAPS_BUSCA = "https://maps.google.com/?cid=13509211634599351926";
export const MAPS_COORDENADAS = "-22.3523084,-49.0503073";
export const MAPS_EMBED = `https://www.google.com/maps?q=${MAPS_COORDENADAS}&z=17&output=embed`;

export const REDES = {
  instagram: "https://www.instagram.com/drthiagoviana",
  youtube: "https://www.youtube.com/@drthiagoviana",
} as const;

export const WHATSAPP =
  "https://tintim.link/whatsapp/275998d7-8dfa-42e4-ac35-593820cbf261/d88ebc9b-2251-495c-a870-4a9088c089c0";

export type ItemMenu = {
  label: string;
  href?: string;
  filhos?: readonly ItemMenu[];
};

export const MENU: readonly ItemMenu[] = [
  { label: "Home", href: "/" },
  { label: "Sobre", href: "/sobre/" },
  { label: "Método SP", href: "/saude-com-proposito/" },
  { label: "Avaliação 360°", href: "/tratamentos/avaliacao-360/" },
  {
    label: "Tratamentos",
    href: "/tratamentos/",
    filhos: [
      { label: "Emagrecimento e saúde metabólica", href: "/tratamentos/emagrecimento/" },
      { label: "Saúde hormonal", href: "/tratamentos/saude-hormonal/" },
      { label: "Massa muscular e sarcopenia", href: "/tratamentos/massa-muscular/" },
      { label: "Medicina do esporte", href: "/tratamentos/medicina-do-esporte/" },
      { label: "Longevidade e qualidade de vida", href: "/tratamentos/longevidade/" },
      { label: "Estética e medicina regenerativa", href: "/tratamentos/estetica-regenerativa/" },
    ],
  },
  {
    label: "Conteúdos",
    filhos: [
      { label: "Blog", href: "/blog/" },
      { label: "Vídeos", href: "/videos/" },
    ],
  },
  {
    label: "Contato",
    filhos: [
      { label: "Consultório em Bauru", href: "/bauru/" },
      { label: "Teleconsulta", href: "/consulta-online/" },
    ],
  },
] as const;

// Subtítulos do mega-menu (só existem no painel do cabeçalho).
export const SUBTITULOS_TRATAMENTOS: Record<string, string> = {
  "Emagrecimento e saúde metabólica": "Perder gordura e destravar o metabolismo",
  "Saúde hormonal": "Masculina · Feminina · Implante hormonal",
  "Massa muscular e sarcopenia": "Perda ou dificuldade de ganho",
  "Medicina do esporte": "Performance, recuperação e lesões de treino",
  "Longevidade e qualidade de vida": "Disposição hoje, saúde no longo prazo",
  "Estética e medicina regenerativa": "Corporal · Facial · Capilar",
};

export const IMAGENS_TRATAMENTOS: Record<string, string> = {
  "Emagrecimento e saúde metabólica": "/imagens/tratamento-emagrecimento.webp",
  "Saúde hormonal": "/imagens/tratamento-saude-hormonal.webp",
  "Massa muscular e sarcopenia": "/imagens/tratamento-massa-muscular.webp",
  "Medicina do esporte": "/imagens/tratamento-medicina-do-esporte.webp",
  "Longevidade e qualidade de vida": "/imagens/tratamento-longevidade.webp",
  "Estética e medicina regenerativa": "/imagens/tratamento-estetica.webp",
};

